import type { Tables } from '~/types/database-helpers';
import { type User } from '@supabase/gotrue-js/src';
import { PlayersService } from '~/lib/services/players.service';

export type Player = Tables<'players'>;
export const usePlayersStore = defineStore('players', {
  state: (): {
    players: Player[];
    total: number;
    pageCount: number;
  } => ({
    players: [],
    total: 0,
    pageCount: 0,
  }),
  actions: {
    setTotal(total: number) {
      this.total = total;
    },
    setPageCount(count: number) {
      this.pageCount = count;
    },
    async fetchPlayers(): Promise<Player[] | null> {
      try {
        const supabase = useSupabaseClient();
        const playersService = new PlayersService(supabase);
        const { data } = await playersService.findAll({
          perPage: 4000,
          sort: { field: 'player_name', ascending: true },
        });
        if (data) {
          this.setPlayers(data);
        }
        return data;
      } catch (error: any) {
        console.error(error);
        return null;
      }
    },
    setPlayers(players: Player[]) {
      this.players = players;
    },
  },
});
